export const enum FormFieldTypeEnum {
    Textarea = "textarea",
    Text = "text",
    Number = "number",
    Date = "date",
    Hidden = "hidden"
}
